<template>
  <div class="app-header">
    <component :is="isHome ? 'div' : 'router-link'" :to="{ name: !authStore.isAuth ? 'login' : 'home' }" class="app-header__logo">
      <SvgIcon icon="logo" class="app-header__icon" />
    </component>
    <AppNavigation v-if="!mainsStore.isMobile && authStore.isAuth" />
    <button v-else-if="mainsStore.isMobile && authStore.isAuth" class="app-header__burger" @click="toggleMenu">
      <SvgIcon :icon="isOpenMenu ? 'close' : 'menu'" class="app-header__burger-icon" />
    </button>
  </div>
  <div v-if="isOpenMenu && mainsStore.isMobile" class="app-header__menu">
    <AppNavigation />
  </div>
</template>

<script lang="ts" src="./AppHeader.ts">
</script>

<style lang="scss" scoped src="./AppHeader.scss"></style>
